import { LegalSlug } from 'types/legal';

// Public legal pages are viewable logged in or out, so the "no session → /login"
// redirects (store/reducers/menu.ts, utils/axios.ts) must leave them alone.
export const PUBLIC_LEGAL_PATHS: Record<LegalSlug, string> = {
  'privacy-policy': '/privacy-policy',
  terms: '/terms'
};

export const isPublicLegalPath = (pathname: string = window.location.pathname): boolean => {
  const path = pathname.replace(/\/+$/, '') || '/';
  return Object.values(PUBLIC_LEGAL_PATHS).includes(path);
};

// Same client-resolution convention as ThemeConfigContext: the first hostname label.
export const getClientDomain = (): string => window.location.hostname.split('.')[0];
